import store from '../../store'

export default function auth ({ next }) {
  if (store.getters.GET_OAUTH && store.getters.GET_OAUTH.access_token) {
    return next()
  }

  return next({ name: 'login' })
}
